import { date, order, list, sentence } from '../formatters.mjs';

// packages/i18n/src/locales/lv.ts
var add = "Pievienot";
var remove = "Noņemt";
var removeAll = "Noņemt visus";
var incomplete = "Piedodiet, visi lauki nav aizpildīti.";
var submit = "Iesniegt";
var noFiles = "Nav izvēlēts fails";
var moveUp = "Uz augšu";
var moveDown = "Uz leju";
var isLoading = "Ielādējas...";
var loadMore = "Ielādēt vēl";
var next = "Tālāk";
var prev = "Atpakaļ";
var addAllValues = "Pievienot visas vērtības";
var addSelectedValues = "Pievienojiet izvēlēto vērtību";
var removeAllValues = "Noņemt visas vērtības";
var removeSelectedValues = "Noņemt izvēlētās vērtības";
var chooseDate = "Izvēlieties datumu";
var changeDate = "Mainīt datumu";
var close = "Aizvērt";
var open = "Atvērt";
var accepted = function({
  name
}) {
  return `Lūdzu apstipriniet ${name}`;
};
var date_after = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${name} jābūt pēc ${date(args[0])}.`;
  }
  return `${name} jābūt pēc šodienas datuma.`;
};
var alpha = function({
  name
}) {
  return `${name} var saturēt tikai alfabētiskās rakstzīmes.`;
};
var alphanumeric = function({
  name
}) {
  return `${name} var saturēt tikai burtus un ciparus.`;
};
var alpha_spaces = function({
  name
}) {
  return `${name} var saturēt tikai burtus un atstarpes.`;
};
var date_before = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${name} jābūt pirms ${date(args[0])}.`;
  }
  return `${name} jābūt pirms šodienas datuma.`;
};
var between = function({
  name,
  args
}) {
  if (isNaN(args[0]) || isNaN(args[1])) {
    return `Šis lauks tika aizpildīts nepareizi un nevar tikt iesniegts.`;
  }
  const [a, b] = order(args[0], args[1]);
  return `${name} jābūt starp ${a} un ${b}.`;
};
var confirm = function({
  name
}) {
  return `${name} nesakrīt.`;
};
var date_format = function({
  name,
  args
}) {
  if (Array.isArray(args) && args.length) {
    return `${name} nav pareizs datums, lūdzu lietojiet formātu ${args[0]}`;
  }
  return "Šis lauks tika aizpildīts nepareizi un nevar tikt iesniegts.";
};
var date_between = function({
  name,
  args
}) {
  return `${name} jābūt starp ${date(args[0])} un ${date(args[1])}`;
};
var email = "Lūdzu ierakstiet pareizu e-pasta adresi.";
var ends_with = function({
  name,
  args
}) {
  return `${name} nebeidzas ar ${list(args)}.`;
};
var is = function({
  name
}) {
  return `${name} nav atļauta vērtība.`;
};
var length = function({
  name,
  args: [first = 0, second = Infinity]
}) {
  const min2 = Number(first) <= Number(second) ? first : second;
  const max2 = Number(second) >= Number(first) ? second : first;
  if (min2 == 1 && max2 === Infinity) {
    return `${name} jābūt vismaz vienam simbolam.`;
  }
  if (min2 == 0 && max2) {
    return `${name} jābūt mazāk par vai ${max2} simboliem.`;
  }
  if (min2 === max2) {
    return `${name} jābūt ${max2} simbolu garumā.`;
  }
  if (min2 && max2 === Infinity) {
    return `${name} jābūt vismaz ${min2} simboliem.`;
  }
  return `${name} jābūt starp ${min2} un ${max2} simboliem.`;
};
var matches = function({
  name
}) {
  return `${name} nav atļauta vērtība.`;
};
var max = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nevar būt vairāk par ${args[0]} ${name}.`;
  }
  return `${name} nevar būt mazāk par ${args[0]} vai ${args[0]}.`;
};
var mime = function({
  name,
  args
}) {
  if (!args[0]) {
    return "Atļauti nenoteikti faila formāti.";
  }
  return `${sentence(name)} faila formāti var būt šādi: ${args[0]}`;
};
var min = function({
  name,
  node: {
    value
  },
  args
}) {
  if (Array.isArray(value)) {
    return `Nevar būt mazāk par ${args[0]} ${name}.`;
  }
  return `Jābūt vismaz ${args[0]} ${name}.`;
};
var not = function({
  name,
  node: {
    value
  }
}) {
  return `“${value}” nav atļauta vērtība iekš ${name}.`;
};
var number = function({
  name
}) {
  return `${name} jābūt ciparam.`;
};
var required = function({
  name
}) {
  return `${name} ir obligāti jāaizpilda`;
};
var starts_with = function({
  name,
  args
}) {
  return `${name} nesākas ar ${list(args)}.`;
};
var url = function() {
  return `Lūdzu pievienojiet pareizu URL.`;
};
var invalidDate = "Izvēlētais datums ir nepareizs.";
var ui = {
  add,
  remove,
  removeAll,
  incomplete,
  submit,
  noFiles,
  moveUp,
  moveDown,
  isLoading,
  loadMore,
  next,
  prev,
  addAllValues,
  addSelectedValues,
  removeAllValues,
  removeSelectedValues,
  chooseDate,
  changeDate,
  close,
  open
};
var validation = {
  accepted,
  date_after,
  alpha,
  alphanumeric,
  alpha_spaces,
  date_before,
  between,
  confirm,
  date_format,
  date_between,
  email,
  ends_with,
  is,
  length,
  matches,
  max,
  mime,
  min,
  not,
  number,
  required,
  starts_with,
  url,
  invalidDate
};
var lv_default = {
  ui,
  validation
};

export { accepted, add, addAllValues, addSelectedValues, alpha, alpha_spaces, alphanumeric, between, changeDate, chooseDate, close, confirm, date_after, date_before, date_between, date_format, lv_default as default, email, ends_with, incomplete, invalidDate, is, isLoading, length, loadMore, matches, max, mime, min, moveDown, moveUp, next, noFiles, not, number, open, prev, remove, removeAll, removeAllValues, removeSelectedValues, required, starts_with, submit, url };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=lv.mjs.map